import { scaleSqrt } from "d3-scale";

const genBubbleScale = () => {
  const maxRange = 7;
  const bubbleScale = scaleSqrt().domain([0, 50]).range([0, maxRange]);
  return bubbleScale;
};
export default genBubbleScale;
